import React, { FormEvent } from 'react';
import Button from '@atlaskit/button';
import Form, { ErrorMessage, Field, FormSection } from '@atlaskit/form';
import Textfield from '@atlaskit/textfield';
import Heading from '@atlaskit/heading';
import Modal, { ModalBody, ModalFooter, ModalHeader, ModalTransition } from '@atlaskit/modal-dialog';

type BulkUserChangeModalProps = {
  closeModal: () => void;
  onSubmitBulkUsersChange: (activeUsersNumber: string) => void;
};

export const BulkUserChangeModal: React.FC<BulkUserChangeModalProps> = ({ closeModal, onSubmitBulkUsersChange }) => {
  const [activeUsersNumber, setActiveUsersNumber] = React.useState<string>();
  const [isValidUsers, setIsValidUsers] = React.useState<boolean>(false);

  const handleActiveUsersChange = () => {
    if (activeUsersNumber) onSubmitBulkUsersChange(activeUsersNumber);
  };

  return (
    <ModalTransition>
      <Modal onClose={closeModal} isBlanketHidden={false} width={'small'} testId="match-bill-date-warning-modal">
        <ModalHeader>
          <Heading size="medium">Enter number of active users</Heading>
        </ModalHeader>
        <ModalBody>
          <Form onSubmit={handleActiveUsersChange}>
            {({ formProps }) => (
              <form {...formProps}>
                <Field
                  name="activeUsersNumber"
                  validate={(value: any) => {
                    const numberPattern = /^[0-9]*$/;
                    if (numberPattern.test(value) && value > 0) {
                      setIsValidUsers(true);
                      return undefined;
                    }
                    setIsValidUsers(false);
                    return 'Invalid active users';
                  }}
                  isRequired
                >
                  {({ fieldProps, error }) => (
                    <>
                      <Textfield
                        {...fieldProps}
                        testId="active-user-number"
                        name="activeUsersNumber"
                        onChange={(event: FormEvent<HTMLInputElement>) => {
                          setActiveUsersNumber(event.currentTarget.value);
                          fieldProps.onChange(event);
                        }}
                      />
                      {error && <ErrorMessage>{error}</ErrorMessage>}
                    </>
                  )}
                </Field>
              </form>
            )}
          </Form>
        </ModalBody>
        <ModalFooter>
          <Button testId="modal-cancel-cta" appearance="subtle" onClick={closeModal}>
            Cancel
          </Button>
          <Button
            testId="modal-confirm-cta"
            appearance="primary"
            onClick={handleActiveUsersChange}
            isDisabled={!isValidUsers}
            autoFocus
          >
            Confirm
          </Button>
        </ModalFooter>
      </Modal>
    </ModalTransition>
  );
};
